import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import { useInvalidateCarriersQuery } from "./use-carriers-query";
import useInvalidateShop from "./use-invalidate-shop";

export function useDeleteCarrierFromShop(shopId: string) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(shopId);
  const invalidateWorkflowListQuery = useInvalidateCarriersQuery({ shopId });

  const mutation = $api.useMutation("delete", "/shops/{shopId}/carriers/{carrierId}");

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      invalidateWorkflowListQuery();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async ({ carrierId }: { carrierId: string }) => {
      return mutation.mutateAsync({ params: { path: { shopId, carrierId } } });
    },
  });
}
